module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/phone-38907b141961634eac252cc50023fe38.svg";